(function(algolia) {
  'use strict';

  let additionalTranslations = {
    learnMore: 'Learn More'
  };

  if (algolia.shopify.market.language.shop_locale.locale == 'de') {
    additionalTranslations = {
      addToCart: "In den Warenkorb",
      outOfStock: "Ausverkauft",
      compare: "Vergleichen",
      sortBy: "Sortiert nach",
      relevance: "Relevanz",
      learnMore: 'Mehr erfahren'
    }
  }
  if (algolia.shopify.market.language.shop_locale.locale == 'it') {
    additionalTranslations = {
      addToCart: "Aggiungi al carrello",
      outOfStock: "Esaurito",
      compare: "Confrontare",
      sortBy: "Ordina per",
      relevance: "In evidenza",
      learnMore: 'Scopri di più'
    }
  }

  if (algolia.shopify.market.language.shop_locale.locale == 'es') {
    additionalTranslations = {
      addToCart: "Añadir al carrito",
      outOfStock: "Agotado",
      compare: "Comparar",
      sortBy: "Ordenar por",
      relevance: "Relevancia",
      learnMore: 'Más información'
    }
  }

  if (algolia.shopify.market.language.shop_locale.locale == 'nl') {
    additionalTranslations = {
      addToCart: "Toevoegen aan winkelwagen",
      outOfStock: "Niet op voorraad",
      compare: "Vergelijken",
      sortBy: "Sorteren op",
      relevance: "Relevantie",
      learnMore: 'Meer informatie'
    }
  }


  if (algolia.shopify.market.language.shop_locale.locale == 'pl') {
    additionalTranslations = {
      addToCart: "Dodaj do koszyka",
      outOfStock: "Niedostępny",
      compare: "Porównaj",
      sortBy: "Sortuj według",
      relevance: "Trafność",
      learnMore: 'Dowiedz się więcej'
    }
  }

  algolia.translations = {
    ...algolia.shopify.market.translations,
    ...additionalTranslations
    // Add additinonal translations here
  };

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return `${algolia.translations.noResultFor} " ${text} ".`;
    },
    in: function(processingTimeMS) {
      return `${algolia.translations.in} ${processingTimeMS / 1000}s`;
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ` ${ algolia.translations.outOf}`
      );
    },

    by: function(text) {
      if (!text) return '';
      return ` ${algolia.translations.by} ` + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliaShopify);
